/**
 * Solid caution triangle from the design system, shown when an uploaded document was unusable.
 *
 * The fill is a fixed status color rather than `currentColor`: it sits beside error text in a
 * different red, so inheriting would be wrong.
 */
function CautionTriangle(props) {
  return (
    <svg
      aria-hidden='true'
      viewBox='0 0 30 30'
      width='30'
      height='30'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      {/* nonzero is set on the shape in the source asset, overriding the group's evenodd; it is
          what knocks the exclamation mark out of the filled triangle. */}
      <path
        fill='#f15d7f'
        fillRule='nonzero'
        d='M3.6 24.5h22.81L15.005 4.8 3.6 24.5Zm12.442-3.111h-2.074v-2.074h2.074v2.074Zm0-4.147h-2.074v-4.148h2.074v4.148Z'
      />
    </svg>
  )
}

export default CautionTriangle
